import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";


const ViewCustomerTable = ({renderAction,AllCustData}) => {
    const [statuses] = useState(["Under Approval","Rejected","Billing Stopped","Approved","Re-submitted","Not Applicable"]);
    const [urbansts] = useState(["Yes","No"]);

  
    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select One" className="p-column-filter" showClear style={{ maxWidth: "12rem" }} />
        );
    };
    const statusRowFilterUrbanTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={urbansts} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select One" className="p-column-filter" showClear style={{ maxWidth: "12rem" }} />
        );
    };
    return (
        <>
            <div className="col-md-12 col-lg-12 col-sm-12">
                <div className="DataTable">
                    <DataTable
                        value={AllCustData}
                        dataKey='MASK_CUST_ID'
                        paginator
                        rows={10}
                        filterDisplay="row"
                        scrollable
                        rowsPerPageOptions={[10, 25, 50]}
                        scrollHeight="80vh"
                        // showGridlines
                        stripedRows
                        globalFilterFields={["PROD_CODE", "DESCRIPTION"]} emptyMessage="No customers found."
                        tableStyle={{ minWidth: "60rem" }}>
                        <Column field="PARTY_CODE" header="Customer Code" filter filterMatchMode="contains" filterPlaceholder="Search Here..." style={{ minWidth: "12rem" }} />
                        <Column field="CUST_NAME" header="Customer Name" style={{ minWidth: "12rem" }} filterMatchMode="contains" filter filterPlaceholder="Search Here..." />
                        <Column field="MASK_CUST_UNIQUE_ID" header="Unique Code" filter filterMatchMode="contains" filterPlaceholder="Search Here..."   />
                        <Column field="MASK_GEOG_DESC" header="Geography Location" filter filterMatchMode="contains" filterPlaceholder="Search Here..."  />
                        <Column field="URBAN_RSE_TAG" header="Urban RSE Status" showFilterMenu={false} filter filterElement={statusRowFilterUrbanTemplate}  style={{ minWidth: "10rem" }} />
                        <Column field="MASK_KYC_STATUS" header="KYC Status" showFilterMenu={false} filter filterElement={statusRowFilterTemplate}  style={{ minWidth: "12rem" }} />
                        <Column field="CUST_EXPIRY_DATE" header="Expiry Date"  style={{ minWidth: "12rem"}} />
                        <Column field={renderAction} header="Action" />
                    </DataTable>
                </div>
            </div>
        </>
    );
};

export default ViewCustomerTable;
